import { motion } from "framer-motion";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { PageHero } from "./AboutPage";
import { MemberCard, TEAM_MEMBERS_LEADERSHIP, TEAM_MEMBERS_EXEC } from "../components/landing/Story";
import { CountUp } from "../components/CountUp";
import { Reveal, Overline } from "../components/Reveal";
import { useLang } from "../context/LanguageContext";

const TEAM_STATS = [
  { key: "temporary", pct: 52 },
  { key: "contract", pct: 80 },
  { key: "direct", pct: 98 },
  { key: "payrolling", pct: 65 },
];

export default function TeamPage() {
  const { t } = useLang();
  return (
    <div className="bg-[#FAF7F2] min-h-screen" data-testid="team-page">
      <Header />
      <PageHero overline={t("teambehind.overline")} title={t("teambehind.title")} sub={t("teambehind.body")} testid="team-title" img="/assets/hero-1.jpg" />

      <section className="pb-20 px-6 sm:px-12" data-testid="team-stats-section">
        <div className="max-w-5xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-5">
          {TEAM_STATS.map((s, i) => (
            <Reveal key={s.key} delay={i * 0.08}>
              <div className="card-light p-6 text-center" data-testid={`teamstat-card-${s.key}`}>
                <div className="font-head font-black text-4xl text-[#E8842C]" dir="ltr"><CountUp to={s.pct} suffix="%" /></div>
                <div className="text-xs font-bold uppercase tracking-widest text-[#1B2A4E]/55 mt-2">{t(`teambehind.${s.key}`)}</div>
                <div className="h-1.5 rounded-full bg-[#1B2A4E]/8 overflow-hidden mt-4">
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: `${s.pct}%` }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                    className="h-full rounded-full bg-gradient-to-r from-[#C96A10] to-[#F5A623]"
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-20 px-6 sm:px-12" data-testid="leadership-section">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <Overline>{t("teambehind.leadership")}</Overline>
            <h2 className="font-head font-black text-2xl sm:text-4xl text-[#1B2A4E]">{t("teambehind.leadership_sub")}</h2>
          </Reveal>
          <div className="grid sm:grid-cols-3 gap-6 mt-10">
            {TEAM_MEMBERS_LEADERSHIP.map((m, i) => <MemberCard key={m.name} m={m} i={i} t={t} />)}
          </div>
        </div>
      </section>

      <section className="pb-28 px-6 sm:px-12" data-testid="executive-section">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <Overline>{t("teambehind.executive")}</Overline>
            <h2 className="font-head font-black text-2xl sm:text-4xl text-[#1B2A4E]">{t("teambehind.executive_sub")}</h2>
          </Reveal>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 mt-10">
            {TEAM_MEMBERS_EXEC.map((m, i) => <MemberCard key={m.name} m={m} i={i} t={t} />)}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
